import { useRequest } from 'ahooks'
import { Carousel, Image } from 'antd'
import { createStyles } from 'antd-style'

import { queryFileDetailBatchApi } from '@eastcoal/api/nexus/oss/queryFileDetailBatch'

import { SkeletonImageGalleryProps } from './interface'

const usestyles = createStyles(({ token }) => ({
  image: {
    maxWidth: '100%',
    [`&+&`]: {
      marginBlockStart: token.marginXS
    }
  }
}))

export const DetailImageGallery = ({ ossIds }: SkeletonImageGalleryProps) => {
  const { data } = useRequest(
    () => queryFileDetailBatchApi({ ossIds }, { silence: true }),
    {
      manual: false,
      ready: !!(ossIds && ossIds.length),
      retryCount: 3,
      retryInterval: 1000
    }
  )

  const { styles } = usestyles()

  return (
    <Image.PreviewGroup preview>
      <Carousel
        arrows
        autoplay
        draggable
        fade
        pauseOnHover
        autoplaySpeed={5000}
        cssEase='ease-in-out'
      >
        {data?.map(({ ossId, accessUrl, filename }) => (
          <Image
            key={`${ossId}`}
            alt={filename}
            rootClassName={styles.image}
            src={`${accessUrl}`}
          />
        ))}
      </Carousel>
    </Image.PreviewGroup>
  )
}
